// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4KaTRx_COV2jL8kojX_K_","preLoaderShimmer":"_3WgoMWa2sUnZlraJim1DTl"};